<template>
  <div v-if="isLoaded" class="wrap" ref="messages">
    <div v-if="scopedMessages && scopedMessages.length" class="messages">
      <div
        v-for="(message, index) in scopedMessages"
        :id="`message_${message.id}`"
        :key="`chat_message_${index}`"
        class="message_wrap"
        :class="{ selected: message.isSelected }"
      >

          <!-- КЛИЕНТ -->
          <div v-if="!message.is_system && message.is_client === true" class="message_body">

            <svg
              width="12" height="20" :fill="getColor('client')"
              class="corner"
            >
              <path d="M 7,14 C 10,10 13,0 13,0 V 20 H 0 c 0,0 6,-3 7,-5 z"/>
            </svg>

            <div
              @click="clickByMessage(message)"
              class="message message-client"
              :style="{backgroundColor: getColor('client')}"
            >
              <div class="content" v-html="message.Htmltext"></div>
              <div class="time">
                {{ formatTime(parseInt(message.start / 1000)) }}
              </div>
            </div>

          </div>

          <!-- ОПЕРАТОР -->
          <div v-if="!message.is_system && message.is_client === false" class="message_body">

            <div
              @click="clickByMessage(message)"
              class="message message-agent"
              :style="{backgroundColor: getColor('agent')}"
            >
              <div class="content" v-html="message.Htmltext"></div>
              <div class="time">
                {{ formatTime(parseInt(message.start / 1000)) }}
              </div>
            </div>

            <svg
              width="12" height="20" :fill="getColor('agent')"
              class="corner"
            >
              <path d="M 5,14 C 2,10 0,0 0,0 v 20 h 13 c 0,0 -6,-3 -7,-5 z"/>
            </svg>

          </div>



          <!-- СИСТЕМНОЕ -->
          <div v-if="message.is_system" class="message_body">
            <div class="message message-system"  :style="{backgroundColor: getColor('system')}">
              <div class="content" v-html="message.Htmltext"></div>
              <div class="time">
                {{ formatTime(parseInt(message.start / 1000)) }}
              </div>
            </div>
          </div>
      </div>
    </div>

    <v-alert v-else dense outlined type="warning"> Стенограммы нет. </v-alert>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Transcribe',
  props: {
    messages: {
      type: Array,
      default() {
        return []
      }
    },

    tableMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoaded: false,
      msgColors: {
        dark: {agent: '#1b5e20', client: '#0d47a1', system: '#333333'},
        light: {agent: '#81c784', client: '#64b5f6', system: '#999999'},
      },
      scopedMessages: [],
    }
  },

  computed: {
    ...mapGetters({
      formatTime: 'audioPlayer/formatTime',
      currentAudio: 'audioPlayer/currentAudio',
      selectedPhrase: 'transcribe/selectedPhrase',
      currentSeconds: 'audioPlayer/currentSeconds',
    }),
  },

  watch: {
    currentSeconds(newVal) {
      if (this.tableMode) return

      this.scopedMessages.forEach(message => { //подсветка текущего сообщения (isSelected)
        if (message.start - 1000 <= newVal * 1000 && newVal * 1000 <= message.end) {
          this.scrollToMessage(message.id)
          this.selectMessage(message)
        }
      })
    },

    selectedPhrase(newVal) {
      if (this.tableMode) return

      let msg = this.scopedMessages.find(msg => msg.id === newVal.phrase_id)

      let re = new RegExp(newVal.name, 'i')
      msg.Htmltext = msg.text
        .replace(re, `<span class="selected-phrase">$&</span>`)
      this.scrollToMessage(newVal.phrase_id)
      this.$forceUpdate()
    },
  },

  methods: {
    clickByMessage(message) {
      if (this.tableMode) return

      this.currentAudio.currentTime = message.start / 1000;
      this.selectMessage(message)
    },

    selectMessage(message) {
      this.scopedMessages.forEach(msg => {
        msg.isSelected = false
      })
      if (message) message.isSelected = true
      this.$forceUpdate()
    },

    scrollToMessage(phraseId) {
      this.$refs['messages'].scrollTo({ //Проскролить к выделенному сообщению
        top: document.querySelector(`#message_${phraseId}`)?.offsetTop - 15,
        behavior: 'smooth',
      })
    },

    getColor(role) {
      let schema = this.$vuetify.theme.dark ? 'dark' : 'light'
      return this.msgColors[schema][role]
    },
  },

  mounted() {
    this.messages?.forEach(msg => {
      msg.isSelected = false
      msg.Htmltext = msg.text
      this.scopedMessages.push(msg)
    })
    this.isLoaded = true
  },
}
</script>

<style>
.selected-phrase {
  padding: 0.4em;
  border-radius: 0.4em;
  font-weight: bold;
  font-size: 1.1em;
  color: #f44336;
  background-color: hsla(0, 0%, 0%, 0.35);
}
.table-transcribe .messages {
  max-height: 100px !important;
}
</style>

<style scoped lang="scss">
.wrap {
  position: relative;
  isolation: isolate;
  padding-block: 0.8rem;
  border-radius: 0.5rem;
  overflow-y: auto;
  background-size: cover;
  width: 100%;
}
.theme--dark .wrap {
  background-image: url("../../../assets/chat_bg_dark.jpg");
}
.theme--light .wrap {
  background-image: url("../../../assets/chat_bg.jpg");
}

.messages {
  max-height: 355px;
}

.message_wrap {
  background-color: transparent;
  transition: background-color 0.5s;

  &.selected {
    background-color: hsla(0, 0%, 0%, 0.4);
  }
}

.message_body {
  display: flex;
  padding-block: 0.2rem;
}
.corner {
  align-self: end;
}
.message {
  display: flex;
  position: relative;
  gap: 0.6rem;
  box-shadow: 0 1px 2px hsla(0,0%,44.7%,.25098);
  padding: 0.5rem;
  cursor: pointer;
  max-width: 80%;
  border-radius: 0.5rem;

  .time {
    color: gray;
    font-size: 0.9em;
    line-height: 1;
    align-self: end;
  }
}
.message-agent {
  margin-left: auto;
  border-bottom-right-radius: 0;
}
.message-client {
  border-bottom-left-radius: 0;
}
.message-system {
  margin-inline: auto;
  cursor: initial;

  .time {
    color: hsla(0, 0%, 100%, 0.5);
  }
}
</style>